import { useLocation } from "react-router-dom"
import { itemTypes } from "./utils";

export const useNoDataList = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const itemType = searchParams.get("item_type");

  const redirectToClaim = () => {
    const nextUrl = searchParams.get("next") || (searchParams.get("claim") ? "" : encodeURIComponent(window.location.origin));
    if (itemType) {
      if (itemType === "other healthcare") {
        return window.location.href = `/dovemed-sso/claim/ohcp/create/?next=${nextUrl}`
      }
      return window.location.href = `/dovemed-sso/claim/${itemType}/create/?next=${nextUrl}`
    }
    return window.location.href = `/dovemed-sso/claim/?next=${nextUrl}`
  }

  return {
    itemType: itemTypes.find((each) => each.value === itemType)?.label || "",
    redirectToClaim,
    showClaimButton: !(itemType === "Business")
  }
}
